module.exports = __webpack_public_path__ + "img/gabriel_fandini.6345f810.jpg";